import * as yup from "yup";
import { MSG } from "../constants/MSG";
import { isPossiblePhoneNumber } from "react-phone-number-input";

export const referralCodeSchema = yup.object().shape({
	referralCode: yup
		.string()
		.trim()
		.matches(/^[A-Z0-9]{1,20}$/, MSG.VALID_REFERRAL_CODE)
		.min(8, MSG.MIN_REFERRAL_CODE)
		.max(8, MSG.MAX_REFERRAL_CODE)
		.required(MSG.REQUIRED_REFERRAL_CODE),
});

export const userInformationSchema = yup.object().shape({
	firstName: yup.string().trim().required(MSG.REQUIRED_FIRST_NAME).nullable(),
	lastName: yup.string().trim().required(MSG.REQUIRED_LAST_NAME).nullable(),
	DOB: yup.string().trim().required(MSG.REQUIRED_DOB).nullable(),
	referralCode: yup
		.string()
		.trim()
		.matches(/^[A-Z0-9]{1,20}$/, MSG.VALID_REFERRAL_CODE)
		.min(8, MSG.MIN_REFERRAL_CODE)
		.max(8, MSG.MAX_REFERRAL_CODE)
		.required(MSG.REQUIRED_REFERRAL_CODE),
});

export const userCredentialsSchema = yup.object().shape({
	email: yup
		.string()
		.trim()
		.email(MSG.REQUIRED_PROPER_EMAIL)
		.required(MSG.REQUIRED_EMAIL)
		.nullable(),
	mobile: yup
		.string()
		.trim()
		.required(MSG.PROVIDE_MOBILE_NUMBER)
		.test("Is Valid Phone Number", MSG.REQUIRED_PROPER_MOBILE_NUMBER, (value) =>
			isPossiblePhoneNumber(value)
		)
		.matches(
			new RegExp(
				/^\+1(?:\d{0})?[-. (]?\d{3}[-. )]?\d{3}[-. ]?\d{4}$/
				// /^\(?([0-9]{0,3})\)?[-. ]?([0-9]{0,3})[-. ]?([0-9]{10,10})$/ //NOSONAR
			),
			MSG.REQUIRED_PROPER_MOBILE_NUMBER
		)
		.nullable(),
	username: yup
		.string()
		.trim()
		.min(3, MSG.MIN_USERNAME)
		.max(20, MSG.MAX_USERNAME)
		.matches(/^(?!\d+$)[A-Za-z0-9_.]+$/, MSG.PROVIDE_VALID_USERNAME)
		.matches(/^[A-Za-z0-9_]/, MSG.VALID_USERNAME_START)
		.required(MSG.REQUIRED_USERNAME)
		.nullable(),
});
